<template>
  <div class="sign-manage-content conmon-top">
    <el-row class="search-title common-table-top" style="margin-top: 20px;padding-right:0">
      <el-col :span="4" class="table-title">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <el-button v-if="butsObj.add" type="primary" @click="changeSearchType" class="add-btn btn-right" style="float: right;margin-left: 0">添加</el-button>
        <el-button v-if="butsObj.update_status" type="primary" class="add-btn list-btn-margin" style="margin-right: 10px" @click="updateSignStatus">更新签名状态</el-button>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table
        :data="tableData"
        v-loading="loading"
        class="table">
        <template slot="empty">
          <div class="newTableEmpty">暂无数据，去<span @click="changeSearchType">新建</span></div>
        </template>
        <el-table-column
          prop="sign_name"
          label="短信签名"
          width="">
        </el-table-column>
        <el-table-column
          label="申请用户">
           <template slot-scope="scope">
            {{ scope.row.user.username}}
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          width="160"
          label="申请时间">
           <template slot-scope="scope">
            {{ scope.row.create_time | formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="150">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <span slot="reference" v-if="scope.row.status === 2" class="red"><span class="pointRed"></span>{{signStatus[scope.row.status] }}</span>
              <span slot="reference" v-if="scope.row.status === 1" class="green"><span class="pointGreen"></span>{{signStatus[scope.row.status] }}</span>
              <span slot="reference" v-if="scope.row.status === 0"><span class="pointGray"></span>{{ signStatus[scope.row.status] }}</span>
              <span v-if="scope.row.check_detail === ''"><span class="pointGray"></span>签名审核中</span>
              <span v-if="scope.row.check_detail !== ''">{{ scope.row.check_detail }}</span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80" style="display: flex;justify-content: center">
          <template slot-scope="scope">
            <div class="op-link deleteColor" v-if="scope.row.status !== 1&&butsObj.del" @click="deleteItem(scope.row)">
              删除
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination
          class="table-foot-pagination"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
     <el-dialog
      title="签名设置"
      :visible.sync="dialogVisible"
      width="550px"
      class="cellDialog base-dialog">
      <div class="dialog-content">
        <!-- <div class="content-one"> -->
          <!-- <span>短信签名:</span> -->
          <el-form ref="addForm" :model="addForm" :rules="rules">
            <el-form-item label="短信签名:" prop="signName" class="content-one">
              <!-- <div class="content-one"> -->
                <el-input v-model="addForm.signName" placeholder="请输入内容" style="width: 240px;"></el-input>
                <el-tooltip class="item" effect="dark" content="签名为3~8个字符，不能包含特殊空格、数字和特殊字符" placement="right">
                  <i class="el-icon-question form-tips"></i>
                </el-tooltip>
              <!-- </div> -->
            </el-form-item>
          </el-form>
        <!-- </div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" @click="dialogVisible = false">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" style="margin-right: 32px" @click="addSmsSignAction">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getSmsSignList, addSmsSign, deleteSign, updateSign } from '@/api/customer.js'
import { butonsList, getMenId } from '@/api/analyse.js'
export default {
  name: 'importData',
  data () {
    return {
      loading: true,
      tableData: [],
      page: 1,
      limit: 10,
      totalCount: 0,
      dialogVisible: false,
      input: '',
      signName: '',
      addForm: {
        signName: ''
      },
      signStatus: {
        0: '审核中',
        1: '审核通过',
        2: '审核失败'
      },
      phoneNum: '',
      rules: {
        signName: [
          { required: true, message: '请输入短信签名', trigger: 'blur' }
        ]
      },
      butsObj: { // button按钮列表
        update_status: false,
        add: false,
        del: false
      }
    }
  },
  methods: {
    // 获取可用菜单按钮列表
    getButtonsList () {
      let params = {
        systemCode: 'ZY_INTELLIQUOR',
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId'),
        menuId: getMenId(this.$route.path)
      }
      butonsList(params).then(res=>{
        if (res.data.code === '200') {
          let result = res.data.result || []
          let arrObj = Object.keys(this.butsObj)
          let newarr  = result.map((item)=>{
            return item.perms
          })
          arrObj.map(it=> {
            if (newarr.indexOf(it)!==-1) {
              this.butsObj[it] = true
            } else {
              this.butsObj[it] = false
            }
          })
        }
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    // 更新签名状态
    updateSignStatus() {
      updateSign().then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', '更新成功')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 删除
    deleteItem(item) {
      this.$confirm('确认删除该签名?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteSign(item.id).then((res) => {
          if (res.data.code === 0) {
            this.load()
            _g.toastMsg('success', '删除签名成功')
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    changeSearchType() {
      this.dialogVisible = true
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.load()
    },
    handleCurrentChange(page) {
      this.page = page
      this.load()
    },
    addSmsSignAction() {
      if (this.addForm.signName === '') {
        _g.toastMsg('error', '请输入文本标签')
        return
      }
      addSmsSign(this.addForm.signName).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          this.dialogVisible = false
        } else {
          _g.toastMsg('error', res.data.error)
          console.log(res.error)
        }
        this.addForm.signName = ''
        this.load()
      })
    },
    load() {
      this.loading = true
      getSmsSignList(this.limit, this.page).then(res => {
        this.tableData = res.data.data.list
        this.totalCount = res.data.data.total
        console.log(res)
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 1000)
    }
  },
  created() {
    this.load()
    this.getButtonsList()
  },
  components: {
  }
}
</script>

<style scoped>
.sign-manage-title {
  background: #ecf6ff;
  border: 1px solid #E4e4e4;
  height:60px;
  padding:10px;
  line-height: 40px;
  margin-top: 10px;
}
.green{
  color: #05B324;
}
.red{
  color: #FF2B2B;
}
.table-title {
  text-align: left;
}
.dialog-content {
}
.content-one span {
  /*display: inline-block;*/
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one{
  /*position: relative;*/
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.form-tips{
  position: absolute;
  font-size: 18px;
  top: 9px;
  right: -20px;
}
.content-one p {
  text-align: left;
}
</style>
